import { apiGet } from '../api';
import { ApiNames, ApiPath } from '../enums';

import { CompanyMerkResponse } from './model';

export async function getCompanyInfoFromMerk(IN: string): Promise<CompanyMerkResponse> {
  return apiGet<CompanyMerkResponse>(ApiNames.MonorepoApiEndpoint, ApiPath.MerkCompanyInfo, false, { id: IN });
}
